// React
import React, { useState, useEffect } from "react";
// React
// CSS
import styles from "./SelectOptionBuilder.module.css";
import SelectOptionBuilderModal from "./SelectOptionBuilderModal/SelectOptionBuilderModal";
// CSS

type SelectOptionBuilderProps = {
  dataForBuildOptions: {
    title: string;
    id: number | string;
  }[];
  initialShowName: string;
  onClick: (data: string) => void;
  className?: string;
  onOpen?: () => boolean;
  elementForShow?: React.ReactNode;
  style?: React.CSSProperties;
};

const SelectOptionBuilder: React.FunctionComponent<
  SelectOptionBuilderProps
> = ({
  dataForBuildOptions,
  initialShowName,
  onClick,
  className,
  onOpen,
  elementForShow,
  style,
}) => {
  const [selectedItem, setSelectedItem] = useState<string>(initialShowName);
  const [isModalInView, setIsModalInView] = useState<boolean>(false);

  useEffect(() => {
    setSelectedItem(initialShowName);
  }, [dataForBuildOptions, initialShowName, elementForShow]);

  // useEffect(() => {
  //   if (!onOpen) return;
  //   const result = onOpen();
  //   if (!result) {
  //     setIsModalInView(false);
  //     return;
  //   }
  // }, [onOpen]);

  console.log("selectedItem", selectedItem);
  return (
    <div
      className={`${styles.selectOptionContainer}  rounded-lg p-1 mt-4  cursor-pointer ${className} dark:!text-black`}
      onClick={() => {
        if (onOpen) {
          if (onOpen()) {
            setIsModalInView(true);
            return;
          }
          return;
        }
        setIsModalInView(true);
      }}
    >
      {/* <select
        className={`${styles.gradeSelect} w-full ${className}`}
        onChange={(e: React.FormEvent<HTMLSelectElement>) => {
          onChange(e.currentTarget.value);
        }}
      >
        <option value="0">{initialShowName}</option>
        {dataForBuildOptions.map((item) => (
          <option value={item.id} key={item.id}>
            {item.title}
          </option>
        ))}
      </select> */}

      {isModalInView ? (
        <SelectOptionBuilderModal
          dataForBuildOptions={dataForBuildOptions}
          onClick={onClick}
          setSelectedItem={setSelectedItem}
          setIsModalInView={setIsModalInView}
          style={style}
        />
      ) : null}

      {elementForShow ? (
        elementForShow
      ) : (
        <p className="w-full text-center dark:!text-black">{selectedItem}</p>
      )}
    </div>
  );
};

export default SelectOptionBuilder;
